import React from 'react'
import {Box, Typography, Button, Stack} from '@mui/material'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'
import {useNavigate} from 'react-router-dom'

// Shown by ProtectedRoute / MultiRoleProtectedRoute when the user's access
// list does not include the role required for a page. Styled to match the
// app palette (primary #2065D1, Minimal-UI grey scale).
const UnauthorizedPage = () => {
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 140px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: 480,
          textAlign: 'center',
          bgcolor: '#fff',
          border: '1px solid #DFE3E8',
          borderRadius: '16px',
          p: {xs: 4, sm: 6},
          boxShadow: '0 12px 32px -8px rgba(145,158,171,0.24)',
        }}
      >
        {/* Icon badge */}
        <Box
          sx={{
            width: 88,
            height: 88,
            mx: 'auto',
            mb: 3,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #D1E9FC 0%, #F4F6F8 100%)',
          }}
        >
          <LockOutlinedIcon sx={{fontSize: 44, color: '#2065D1'}} />
        </Box>

        <Typography
          sx={{fontSize: 13, fontWeight: 700, letterSpacing: '1.5px', color: '#2065D1', mb: 1}}
        >
          ERROR 401
        </Typography>

        <Typography sx={{fontSize: 24, fontWeight: 700, color: '#212B36', mb: 1.5}}>
          Access Denied
        </Typography>

        <Typography sx={{fontSize: 14, color: '#637381', lineHeight: 1.6, mb: 4}}>
          You don&apos;t have permission to view this page. Your account isn&apos;t
          authorized for this module — if you believe this is a mistake, please
          contact your administrator.
        </Typography>

        <Stack direction={{xs: 'column', sm: 'row'}} spacing={1.5} justifyContent="center">
          <Button
            variant="outlined"
            startIcon={<ArrowBackOutlinedIcon />}
            onClick={() => navigate(-1)}
            sx={{
              textTransform: 'none',
              borderRadius: '8px',
              borderColor: '#DFE3E8',
              color: '#454F5B',
              px: 2.5,
              '&:hover': {borderColor: '#919EAB', bgcolor: '#F9FAFB'},
            }}
          >
            Go Back
          </Button>
          <Button
            variant="contained"
            startIcon={<HomeOutlinedIcon />}
            onClick={() => navigate('/home')}
            sx={{
              textTransform: 'none',
              borderRadius: '8px',
              bgcolor: '#2065D1',
              px: 2.5,
              boxShadow: 'none',
              '&:hover': {bgcolor: '#103996', boxShadow: 'none'},
            }}
          >
            Back to Home
          </Button>
        </Stack>
      </Box>
    </Box>
  )
}

export default UnauthorizedPage
